<script>
export default {
	props: {
		slides: Array,
	},
}
</script>
<template>
	<Carousel
		class="appbar-bottom-carousel"
		:gutter="0"
		:feather="30"
		paginate-by-slide
		no-drag
		show-arrows
		v-bind="$attrs"
	>
		<div v-for="(slide, n) in slides" :key="n" class="__slide">
			<SafeLink :to="slide.link">
				<Media class="__image" :src="slide.image" width="150" />
				<HtmlOrSlot :text="slide.name">
					<h3 class="__title">{{ slide.name }}</h3>
				</HtmlOrSlot>
			</SafeLink>
		</div>
	</Carousel>
</template>

<style scoped lang="scss">
.appbar-bottom-carousel {
	padding: 24px;

	.__slide {
		.__image {
			margin: 0 auto;
			height: 100%;
		}

		.__title {
			text-align: center;
			color: var(--ctatext);
		}
		&:hover .__title {
			text-decoration: underline;
			color: var(--strongtext);
		}
	}
}
</style>

